import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
    requestUserNotifications(context) {
        Vue.http.get(
            context.getters.endpoint + '/db/notifications', {
                emulateJSON: true,
                params: {},
                headers: context.getters.secureHeaders
            }).then((n) => {
            if (n.body.result) {
                context.commit('updateUserNotifications', n.body.data)
            } else {
                console.log(n.body)
            }
        });
    }
}